// theme.js - Enhanced Main JavaScript with Full Shopify Checkout Integration

document.addEventListener('DOMContentLoaded', function() {
  initMobileMenu();
  initCartDrawer();
  initPredictiveSearch();
  initStickyHeader();
  initLazyLoading();
  initQuantityButtons();
  updateCartCount();
  initProductCards();        // <-- initialise product card handlers
  
  // Load any Shopify-specific checkout scripts
  loadShopifyCheckoutScripts();
});

function initMobileMenu() {
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileDrawer = document.querySelector('#MobileMenuDrawer');
  const overlay = document.querySelector('.overlay');
  
  if (!menuBtn || !mobileDrawer) return;
  
  menuBtn.addEventListener('click', () => {
    mobileDrawer.classList.add('open');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  });
  
  function closeDrawer() {
    mobileDrawer.classList.remove('open');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  const closeBtn = mobileDrawer.querySelector('.drawer__close');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
}

function initCartDrawer() {
  const cartIcon = document.querySelector('.cart-icon');
  const cartDrawer = document.querySelector('#CartDrawer');
  const overlay = document.querySelector('.overlay');
  
  if (!cartIcon || !cartDrawer) return;
  
  cartIcon.addEventListener('click', async () => {
    cartDrawer.classList.add('open');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (typeof fetchAndRenderCart === 'function') {
      await fetchAndRenderCart();
    }
  });
  
  function closeDrawer() {
    cartDrawer.classList.remove('open');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  const closeBtn = cartDrawer.querySelector('.drawer__close');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
}

function initPredictiveSearch() {
  const searchIcon = document.querySelector('.search-icon');
  const searchModal = document.querySelector('.search-modal');
  let searchInput = null;
  
  if (!searchIcon) return;
  
  searchIcon.addEventListener('click', () => {
    if (searchModal) {
      searchModal.hidden = !searchModal.hidden;
      searchInput = searchModal.querySelector('.search-input');
      if (searchInput) searchInput.focus();
    }
  });
  
  if (searchModal) {
    let debounceTimer;
    searchInput = searchModal.querySelector('.search-input');
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          performSearch(e.target.value);
        }, 300);
      });
    }
  }
}

async function performSearch(query) {
  if (query.length < 2) {
    const resultsContainer = document.querySelector('.search-results');
    if (resultsContainer) resultsContainer.innerHTML = '';
    return;
  }
  
  try {
    const response = await fetch(`/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
    const data = await response.json();
    const results = data.resources?.results?.products || [];
    displaySearchResults(results);
  } catch (error) {
    console.error('Search error:', error);
  }
}

function displaySearchResults(products) {
  const resultsContainer = document.querySelector('.search-results');
  if (!resultsContainer) return;
  
  if (products.length === 0) {
    resultsContainer.innerHTML = '<p class="search-no-results">No products found</p>';
    return;
  }
  
  let html = '<ul class="search-results-list">';
  products.forEach(product => {
    html += `
      <li>
        <a href="${product.url}">
          <img src="${product.image}" width="50" height="50" alt="${product.title}" loading="lazy">
          <div>
            <h4>${product.title}</h4>
            <p>${formatMoney(product.price)}</p>
          </div>
        </a>
      </li>
    `;
  });
  html += '</ul>';
  resultsContainer.innerHTML = html;
}

function initStickyHeader() {
  const header = document.querySelector('.header');
  if (!header) return;
  
  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll > 100) {
      header.classList.add('header-scrolled');
      header.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
    } else {
      header.classList.remove('header-scrolled');
      header.style.boxShadow = 'none';
    }
  });
}

function initLazyLoading() {
  const lazyImages = document.querySelectorAll('img[data-src]');
  if (lazyImages.length === 0) return;
  
  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.classList.add('loaded');
        imageObserver.unobserve(img);
      }
    });
  });
  
  lazyImages.forEach(img => imageObserver.observe(img));
}

function initQuantityButtons() {
  // Quantity buttons will be handled in cart-drawer
}

async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  } catch (error) {
    console.error('Error updating cart count:', error);
  }
}

function formatMoney(cents) {
  const amount = cents / 100;
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
}

function showToast(message, type = 'success') {
  const existingToast = document.querySelector('.toast-notification');
  if (existingToast) existingToast.remove();
  
  const toast = document.createElement('div');
  toast.className = `toast-notification toast-${type}`;
  toast.textContent = message;
  document.body.appendChild(toast);
  
  setTimeout(() => toast.remove(), 3000);
}

function loadShopifyCheckoutScripts() {
  // Shopify's dynamic checkout buttons will load automatically
  // This ensures express checkout buttons work properly
  if (window.Shopify && Shopify.Checkout) {
    console.log('Shopify checkout scripts loaded');
  }
}

// Global function for checkout
window.redirectToCheckout = function() {
  window.location.href = '/checkout';
};

// Global function for closing drawer
window.closeCartDrawer = function() {
  const cartDrawer = document.querySelector('#CartDrawer');
  const overlay = document.querySelector('.overlay');
  if (cartDrawer) cartDrawer.classList.remove('open');
  if (overlay) overlay.classList.remove('active');
  document.body.style.overflow = '';
};

// Global function for updating cart
window.updateCartItemQuantity = async function(key, quantity) {
  if (quantity < 1) {
    await window.removeFromCart(key);
    return;
  }
  
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    
    if (response.ok) {
      if (typeof fetchAndRenderCart === 'function') {
        await fetchAndRenderCart();
      }
      await updateCartCount();
      showToast('Cart updated');
    }
  } catch (error) {
    console.error('Error updating quantity:', error);
    showToast('Error updating cart', 'error');
  }
};

// Global function for removing from cart
window.removeFromCart = async function(key) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    
    if (response.ok) {
      if (typeof fetchAndRenderCart === 'function') {
        await fetchAndRenderCart();
      }
      await updateCartCount();
      showToast('Item removed from cart');
    }
  } catch (error) {
    console.error('Error removing item:', error);
    showToast('Error removing item', 'error');
  }
};

/* ========================
   Global product card handler (replaces inline scripts in product-card.liquid)
   ======================== */

function initProductCards() {
  document.querySelectorAll('.quick-add').forEach(btn => {
    btn.removeEventListener('click', handleCardAddToCart);
    btn.addEventListener('click', handleCardAddToCart);
  });
}

async function handleCardAddToCart(e) {
  e.preventDefault();
  const btn = e.currentTarget;
  const variantId = btn.dataset.variantId;
  const productTitle = btn.dataset.productTitle;

  if (!variantId) {
    showToast('Error: Product variant not found');
    return;
  }

  const originalText = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    });

    if (response.ok) {
      showToast(`✓ ${productTitle} added to cart!`);
      updateCartCount();

      const cartDrawer = document.querySelector('#CartDrawer');
      const overlay = document.querySelector('.overlay');
      if (cartDrawer) {
        cartDrawer.classList.add('open');
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        if (typeof fetchAndRenderCart === 'function') {
          await fetchAndRenderCart();
        }
      }
    } else {
      const error = await response.json();
      showToast(error.description || 'Error adding to cart');
    }
  } catch (error) {
    showToast('Error adding to cart. Please try again.');
  } finally {
    btn.textContent = originalText;
    btn.disabled = false;
  }
}

// Re-run when new products are loaded via AJAX (search results, cart updates, etc.)
const productCardObserver = new MutationObserver(() => initProductCards());
productCardObserver.observe(document.body, { childList: true, subtree: true });